module.exports = __webpack_public_path__ + "static/media/location-pin-white.2e0c5a61.svg";